function handleTabs() {
	const tabGroups = document.getElementsByClassName(
		"wp-block-eyeworkers-tab-group"
	);
	if (!tabGroups) return;

	// Loop through every TabGroup on page
	for (let i = 0; i < tabGroups.length; i++) {
		const buttons = tabGroups[i].querySelectorAll(".tab-row > button");
		const tabContainer = tabGroups[i].querySelector(":scope > div:not(.tab-row)");
		const tabs = tabContainer.querySelectorAll(
			".wp-block-eyeworkers-tab-content"
		);

		if (buttons.length != tabs.length) return;

		// Set defaults
		let activePage = 0;
		buttons[0].classList.add("active");
		tabs[0].classList.add("active");

		// Loop through the elements and apply aria-controlls
		for (let j = 0; j < buttons.length; j++) {
			const tabId = "tab-content-" + buttons[j].id;
			tabs[j].setAttribute("id", tabId);
			buttons[j].setAttribute("aria-controls", tabId);
			buttons[j].setAttribute("aria-expanded", j == 0);

			buttons[j].addEventListener("click", () => {
				// On click toggle attributes of selected and unselected elements
				if (activePage != j) {
					activePage = j;
					buttons[j].setAttribute("aria-expanded", true);
					buttons[j].classList.toggle("active");
					tabs[j].classList.toggle("active");
					for (let k = 0; k < buttons.length; k++) {
						if (k != j) {
							buttons[k].setAttribute("aria-expanded", false);
							buttons[k].classList.remove("active");
							tabs[k].classList.remove("active");
						}
					}
				}
			});
		}
	}
}

document.addEventListener("DOMContentLoaded", handleTabs);
